import { Dialog, Pane, TextareaField, TextInputField, Button, toaster, SelectMenu, FormField } from 'evergreen-ui';
import { ConfirmIcon, TrashIcon } from 'evergreen-ui';
import { useState, useEffect } from 'react';
import DiaryService from '../services/diaryService';

const EditNoteDialog = ({ isShown, onClose, note, currentUserIsDirector, onSaved, guests = [] }) => {
  const [azione, setAzione] = useState('');
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [selectedGuestId, setSelectedGuestId] = useState('');
  const [isNarrow, setIsNarrow] = useState(typeof window !== 'undefined' ? window.innerWidth < 560 : false);

  useEffect(() => {
    if (note) {
      setAzione(note.azione || '');
      setStart(note.start_orario || note.orario || '');
      setEnd(note.end_orario || '');
      setSelectedGuestId(note.guest_id ? String(note.guest_id) : '');
    }
  }, [note]);

  useEffect(() => {
    const onResize = () => setIsNarrow(window.innerWidth < 560);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const authorName = note ? ((note.user_nome || '') + (note.user_cognome ? ' ' + note.user_cognome : '')).trim() || note.recorded_by || note.user_name || '' : '';
  const handleSave = async () => {
    try {
      const payload = { note_id: note.id || note.note_id, azione, start_orario: start, end_orario: end };
      if (selectedGuestId !== undefined) {
        // send integer guest id or null
        payload.guest_id = selectedGuestId === '' ? null : parseInt(selectedGuestId, 10);
      }
      const res = await DiaryService.updateNote(payload);
      if (res && res.success) {
        toaster.success('Nota aggiornata');
        onSaved && onSaved();
        onClose && onClose();
      } else {
        toaster.danger(res.error || 'Errore');
      }
    } catch (e) {
      console.error(e);
      toaster.danger('Errore durante il salvataggio');
    }
  };

  const handleDelete = async () => {
    if (!currentUserIsDirector) { toaster.danger('Permesso negato'); return; }
    if (!note || !(note.id || note.note_id)) { toaster.danger('note_id mancante'); return; }
    try {
      const res = await DiaryService.deleteNote(note.id || note.note_id);
      if (res && res.success) {
        toaster.success('Nota rimossa');
        onSaved && onSaved();
        onClose && onClose();
      } else {
        toaster.danger(res.error || 'Errore durante la cancellazione');
      }
    } catch (e) {
      console.error(e);
      toaster.danger('Errore durante la cancellazione');
    }
  };

  return (
    <Dialog isShown={isShown} title="Modifica nota aggiuntiva" onCloseComplete={onClose} hasFooter={false} shouldAutoFocus={false}>
      <FormField label="Autore" marginBottom={16}>
        <TextInputField value={authorName} disabled />
      </FormField>

      <FormField label="Ospite coinvolto">
        <SelectMenu
          title="Seleziona ospite"
          options={[{ label: 'Nessuno', value: '' }, ...(guests || []).map(g => ({ label: `${g.nome} ${g.cognome}`, value: String(g.id) }))]}
          selected={selectedGuestId ? [String(selectedGuestId)] : []}
          onSelect={(item) => setSelectedGuestId(item.value)}
        >
          <Button style={{ maxWidth: '100%', width: 'auto', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {selectedGuestId ? ((guests || []).find(g => String(g.id) === String(selectedGuestId)) ? `${(guests || []).find(g => String(g.id) === String(selectedGuestId)).nome} ${(guests || []).find(g => String(g.id) === String(selectedGuestId)).cognome}` : 'Seleziona ospite') : 'Nessuno'}
          </Button>
        </SelectMenu>
      </FormField>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
          <div style={{ flex: '1 1 160px', minWidth: 140 }}>
            <TextInputField
              label="Ora di inizio"
              value={start}
              onChange={e => setStart(e.target.value)}
              placeholder="HH:MM"
              inputProps={{ type: 'time' }}
              style={{ width: '100%' }}
            />
          </div>

          <div style={{ flex: '1 1 160px', minWidth: 140 }}>
            <TextInputField
              label="Ora di fine"
              value={end}
              onChange={e => setEnd(e.target.value)}
              placeholder="HH:MM"
              inputProps={{ type: 'time' }}
              style={{ width: '100%' }}
            />
          </div>
      </div>

      <TextareaField label="Azione" value={azione} onChange={e => setAzione(e.target.value)} inputHeight={160} flexibleHeight />

      <Pane display="flex" gap={8} marginTop={8} justifyContent="flex-end" style={{ flexDirection: isNarrow ? 'column' : 'row' }}>
        {currentUserIsDirector && (
          <Button intent="danger" onClick={handleDelete} style={{ width: isNarrow ? '100%' : 'auto' }}>
            Elimina nota<TrashIcon marginLeft={8} />
          </Button>
        )}
        <Button appearance="primary" intent="success" onClick={handleSave} style={{ width: isNarrow ? '100%' : 'auto' }}>
          Conferma modifica <ConfirmIcon marginLeft={8} />
        </Button>
      </Pane>
    </Dialog>
  );
};

export default EditNoteDialog;
